import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify'
import { UserInfoService } from '@eureka/domains/src/user-info'
import type { AgentUploadLimitStrategy } from './agent-upload-limit-strategy'

@injectable()
export class SarUploadLimitStrategy implements AgentUploadLimitStrategy {
    private _userInfoService: UserInfoService

    constructor(@inject(UserInfoService) userInfoService: UserInfoService) {
        this._userInfoService = userInfoService
    }

    async getLimit(): Promise<number | undefined> {
        const [isEnterpriseCommercial, isTrial, isFreeUser, isPro] = await Promise.all([
            this._userInfoService.getIsEnterpriseCommercialUser(),
            this._userInfoService.getIsTrialUser(),
            this._userInfoService.getIsFreeUser(),
            this._userInfoService.getIsPro()
        ])
        if (isFreeUser) return 2
        if (isPro) return 5
        if (isEnterpriseCommercial || isTrial) return 10

        return 2
    }
}
